module.exports = __webpack_public_path__ + "static/img/pin-add.16d8c4f.svg";